import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const EnrollStatusService = {
  create,
  update,
  getStatusesByPagination,
  getAllStatuses,
};

async function getAllStatuses() {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/enrollment-status/getAll/`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function create(enrollment_status) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(enrollment_status),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/enrollment-status/add/`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function update(enrollment_status, enrollment_status_id) {
  const requestOptions = {
    method: "PUT",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(enrollment_status),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/enrollment-status/update/${enrollment_status_id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function getStatusesByPagination(limit, offset, search_term) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/enrollment-status/getAllEnrollStatuses/?limit=${limit}&offset=${offset}&search_term=${search_term}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}
